import { ComponentPropsWithRef } from "react";
import { Heading } from "../generic/Heading";
import { IconCircle } from "../generic/IconCircle";
import { Logo } from "../icons/Logo";
import { MainWindow } from "./MainWindow";

export interface ErrorProps {
  title?: string;
  message?: string;
  actions?: React.ReactNode;
  icon?: ComponentPropsWithRef<typeof IconCircle>["icon"];
  children?: React.ReactNode;
}

export const ErrorPage = ({
  title,
  message,
  icon,
  actions,
  children,
}: ErrorProps) => {
  return (
    <div
      id="error-page"
      className="flex min-h-full grow flex-col gap-y-3 p-3.5 xl:p-7"
    >
      <div className="flex h-[37px] w-full shrink-0 items-center px-4 text-white">
        <div className="flex items-center gap-x-2">
          <Logo className="w-16" />
        </div>
      </div>
      <MainWindow className="flex size-full items-center justify-center p-14">
        <div className="flex flex-col items-center justify-center gap-y-6">
          {children ? (
            children
          ) : (
            <>
              {icon && <IconCircle icon={icon} />}
              <div className="flex flex-col gap-y-4 text-center text-base leading-normal font-medium">
                {title && (
                  <Heading level={1} className="text-theme-on-background">
                    {title}
                  </Heading>
                )}
                {message && (
                  <p className="text-theme-on-background-variant max-w-2xl leading-snug">
                    {message}
                  </p>
                )}
              </div>
            </>
          )}
          <div className="mt-4 flex gap-x-6">{actions}</div>
        </div>
      </MainWindow>
    </div>
  );
};
